// 判断是否在客户端的hooks
import { useEffect, useState } from "react";
export const useIsClient = () => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return isClient;
};
